"use strict";
/* Auto Generated */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheType = void 0;
var CacheType;
(function (CacheType) {
    CacheType[CacheType["patreons"] = 0] = "patreons";
    CacheType[CacheType["dashboard"] = 1] = "dashboard";
    CacheType[CacheType["dashboardLoggedIn"] = 2] = "dashboardLoggedIn";
    CacheType[CacheType["guideSearch"] = 3] = "guideSearch";
    CacheType[CacheType["donation"] = 4] = "donation";
    CacheType[CacheType["version"] = 5] = "version";
    CacheType[CacheType["guideContent"] = 6] = "guideContent";
    CacheType[CacheType["appReview"] = 7] = "appReview";
    CacheType[CacheType["steamNews"] = 8] = "steamNews";
    CacheType[CacheType["steamBranches"] = 9] = "steamBranches";
    CacheType[CacheType["emojiLeaderboard"] = 10] = "emojiLeaderboard";
    CacheType[CacheType["kurtBlogRss"] = 11] = "kurtBlogRss";
    CacheType[CacheType["kurtIsLive"] = 12] = "kurtIsLive";
    CacheType[CacheType["teamMembers"] = 13] = "teamMembers";
    CacheType[CacheType["translators"] = 14] = "translators";
    CacheType[CacheType["translatorLeaderboard"] = 15] = "translatorLeaderboard";
    CacheType[CacheType["badges"] = 16] = "badges";
    CacheType[CacheType["exportLang"] = 17] = "exportLang";
    CacheType[CacheType["translationsGraph"] = 18] = "translationsGraph";
    CacheType[CacheType["twitchUserImg"] = 19] = "twitchUserImg";
    CacheType[CacheType["twitchUserData"] = 20] = "twitchUserData";
    CacheType[CacheType["patreonLogin"] = 21] = "patreonLogin";
    CacheType[CacheType["appNotice"] = 22] = "appNotice";
    CacheType[CacheType["feedbackForm"] = 23] = "feedbackForm";
})(CacheType = exports.CacheType || (exports.CacheType = {}));
